import { createAsyncThunk } from '@reduxjs/toolkit'
import { getBlackjackGameReportService, getChopperCrashGameReportService, getCoinFlipGameReportService, getCrashGameReportService, getDiceGameReportService, getGongaMineGameReportService, getHiloGameReportService, getKenoGameReportService, getLimboGameReportService, getMinesGameReportService, getMultiCrashGameReportService, getPlinkoGameReportService, getPyramidPlinkoGameReportService, getRouletteGameReportService, getSoccerCrashGameReportService, getSpaceDiceGameReportService, getVideoPokerGameReportService,getTowerGameReportService,getCrossGameReportService } from 'network/services/game.service'

export const fetchCrashGameReport = createAsyncThunk(
  'fetch/crashGameReport',
  async (data, thunkApi) => {
    try {
      const res = await getCrashGameReportService({ gameId: 1 })
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchDiceGameReport = createAsyncThunk(
  'fetch/diceGameReport',
  async (data, thunkApi) => {
    try {
      const res = await getDiceGameReportService({ gameId: 8 })
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchPlinkoGameReport = createAsyncThunk(
  'fetch/plinkoGameReport',
  async (data, thunkApi) => {
    try {
      const res = await getPlinkoGameReportService({ gameId: 5 })
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchKenoGameReport = createAsyncThunk(
  'fetch/kenoGameReport',
  async (data, thunkApi) => {
    try {
      const res = await getKenoGameReportService({ gameId: 7 })
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchVideoPokerGameReport = createAsyncThunk(
  'fetch/videoPokerGameReport',
  async (data, thunkApi) => {
    try {
      const res = await getVideoPokerGameReportService({ gameId: 9 })
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchHiloGameReport = createAsyncThunk(
  'fetch/hiloGameReport',
  async (data, thunkApi) => {
    try {
      const res = await getHiloGameReportService({ gameId: 10 })
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchBlackjackGameReport = createAsyncThunk(
  'fetch/blackjackGameReport',
  async (data, thunkApi) => {
    try {
      const res = await getBlackjackGameReportService({ gameId: 11 })
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchLimboGameReport = createAsyncThunk(
  'fetch/limboGameReport',
  async (data, thunkApi) => {
    try {
      const res = await getLimboGameReportService({ gameId: 12 })
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchMinesGameReport = createAsyncThunk(
  'fetch/minesGameReport',
  async (data, thunkApi) => {
    try {
      const res = await getMinesGameReportService({ gameId: 13 })
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchRouletteGameReport = createAsyncThunk(
  'fetch/rouletteGameReport',
  async (data, thunkApi) => {
    try {
      const res = await getRouletteGameReportService({ gameId: 15 })
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchCoinFlipGameReport = createAsyncThunk(
  'fetch/coinflipGameReport',
  async (data, thunkApi) => {
    try {
      const res = await getCoinFlipGameReportService({ gameId: 17 })
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchMultiCrashGameReport = createAsyncThunk(
  'fetch/multiCrashGameReport',
  async (data, thunkApi) => {
    try {
      const res = await getMultiCrashGameReportService({ gameId: 2 })
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchChopperCrashGameReport = createAsyncThunk(
  'fetch/chopperCrashGameReport',
  async (data, thunkApi) => {
    try {
      const res = await getChopperCrashGameReportService({ gameId: 3 })
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchSoccerCrashGameReport = createAsyncThunk(
  'fetch/soccerCrashGameReport',
  async (data, thunkApi) => {
    try {
      const res = await getSoccerCrashGameReportService({ gameId: 4 })
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchPyramidPlinkoGameReport = createAsyncThunk(
  'fetch/pyramidPlinkoGameReport',
  async (data, thunkApi) => {
    try {
      const res = await getPyramidPlinkoGameReportService({ gameId: 6 })
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchGongaMineGameReport = createAsyncThunk(
  'fetch/gongaMineGameReport',
  async (data, thunkApi) => {
    try {
      const res = await getGongaMineGameReportService({ gameId: 14 })
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchSpaceDiceGameReport = createAsyncThunk(
  'fetch/spaceDiceGameReport',
  async (data, thunkApi) => {
    try {
      const res = await getSpaceDiceGameReportService({ gameId: 16 })
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchTowerGameReport = createAsyncThunk(
  'fetch/towerGameReport',
  async (data, thunkApi) => {
    try {
      const res = await getTowerGameReportService({ gameId: 24 })
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchCrossGameReport = createAsyncThunk(
  'fetch/crossGameReport',
  async (data, thunkApi) => {
    try {
      const res = await getCrossGameReportService({ gameId: 24 })
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)